<template>
  <section id="team" class="bg-gray-900 py-16 px-6">
    <div class="max-w-7xl mx-auto text-center mb-12">
      <h2 class="text-3xl md:text-4xl font-bold text-white mb-4">
        Meet Our Team
      </h2>
      <p class="text-gray-400 text-lg">
        A passionate group of developers and designers building awesome experiences.
      </p>
    </div>

    <!-- Team Cards -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto">
      <div
        v-for="member in team"
        :key="member.name"
        class="bg-gray-800 rounded-xl shadow-lg overflow-hidden transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl"
      >
        <!-- ✅ Changed object-cover → object-contain + bg-black for padding color -->
        <img
          :src="member.image"
          :alt="member.name"
          class="w-full h-64 object-contain bg-black"
        />
        <div class="p-6 text-center">
          <h3 class="text-xl font-bold text-white mb-2">
            {{ member.name }}
          </h3>
          <p class="text-blue-400 font-medium mb-3">
            {{ member.role }}
          </p>
          <p class="text-gray-400 text-sm leading-relaxed">
            {{ member.bio }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import kirby from '@/assets/kirby.jpeg';
import jomell from '@/assets/jomell.jpg';
import furing from '@/assets/furing.png';
import nere from '@/assets/nere.jpg';
import jing from '@/assets/jing.jpg';
import que from '@/assets/que.jpg';

export default {
  name: "TeamSection",
  data() {
    return {
      team: [
        {
          name: "Engr. Jomell Hope Dela Peña",
          role: "Full Stack Developer",
          image: jomell,
          bio: ""
        },
        {
          name: "Engr. John Paul Furing",
          role: "Full Stack Developer",
          image: furing,
          bio: ""
        },
        {
          name: "Engr. Kirby Jade Labalan",
          role: "Full Stack Developer",
          image: kirby,
          bio: ""
        },
        {
          name: "Engr. Nerizza Bayas",
          role: "Backend Developer (Python)",
          image: nere,
          bio: ""
        },
        {
          name: "Jinkyrine Naguit",
          role: "Social Media Manager",
          image: jing,
          bio: ""
        },
        {
          name: "Margarette Merillo",
          role: "Marketing Manager",
          image: que,
          bio: ""
        },
      ]
    };
  }
};
</script>

<style scoped>
/* Smooth hover effect for card images */
img {
  transition: transform 0.5s ease;
}
div:hover img {
  transform: scale(1.05);
}
</style>
